import React from 'react';
import Header from './Header';

interface SelectProps{
    children: React.ReactNode,
    className:string,
    subTitle?:string,
    isMain?:boolean,
    classificationFlowIndex?:number,
    mainTitle?:string
}
const SiaContainer = (props:SelectProps) => {
    const {children, className = '', subTitle = 'Choose project or create a new one', isMain = false, classificationFlowIndex = -1, mainTitle = 'Tagging Platform'} = props;

    return (
        <>
            <div className={className}>
                <Header
                    mainTitle={mainTitle}
                    subTitle={subTitle}
                    isMain={isMain}
                    classificationFlowIndex={classificationFlowIndex}
                    {...props}
                />
                {children}
            </div>
        </>
    );
};

export default SiaContainer;
